import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { Maybe } from "@entrilia/shared/types";
import type { ConditionField } from "../../../../../../../../../../api/types/svTypes";
import { getConditionFieldCaption } from "./conditionSelectHelpers";

interface Props {
  selectedConditionGuid: Maybe<string>;
  onSelectedConditionGuidChange: (conditionGuid: string) => void;
  conditions: ConditionField[];
  selectedConditionGuidError: string | undefined;
  readonly: boolean;
}

const ConditionSelect = ({
  selectedConditionGuid,
  onSelectedConditionGuidChange,
  conditions,
  selectedConditionGuidError,
  readonly,
}: Props) => {
  return (
    <FormControl error={!!selectedConditionGuidError}>
      <InputLabel id="condition-value-condition-label">Condition</InputLabel>
      <Select
        labelId="condition-value-condition-label"
        label="Condition"
        value={selectedConditionGuid ?? ""}
        onChange={(evt) => onSelectedConditionGuidChange(String(evt.target.value ?? ""))}
        disabled={readonly}
      >
        {conditions.map((condition) => (
          <MenuItem key={condition.config.guid} value={condition.config.guid}>
            {getConditionFieldCaption(condition)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ConditionSelect;
